<template lang="pug">
.vld-parent
  EditableControl(:id="id" :displayValue="displayValue" :bus="bus" :editing="editing" :editByDefault="editByDefault" :errors="errors" :navigationRoute="navigationRoute")
    .dropdown
      VueSelector(:class="classes" v-model='selected_' :items='mappedCollection' :searchable="searchable" :placeholder="placeholder_" :clearable="clearable" @search:focus="onFocus" @input="onUpdate" @change="onChange_" :grow="grow")
        template(#dropdown-first-item="{ dir, noItemsText }")
          slot(name="dropdown-first-item" :dir="dir" :noItemsText="noItemsText")
        template(#dropdown-no-items="{ dir, noItemsText }")
          slot(name="dropdown-no-items" :dir="dir" :noItemsText="noItemsText")
        template(#dropdown-item="{ dir, item, index }")
          slot(name="dropdown-item" :dir="dir" :item="item" :index="index")

    slot
</template>

<script>
import { Events } from "../Block/index";
import "./scss";
import { mixins } from "../EditableControl/mixins";
import * as ApiRoutes from "@timesheets/routes-api-common";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { Arrays, idComparer, stringSort } from "@gemma/utils";
import { GemmaError } from "@gemma/errors";

export default {
  name: "Dropdown",
  mixins: [mixins("selected")],
  props: {
    classes: {
      type: [String, Array, Object],
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
    },
    type: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
    canBeEmpty: {
      type: Boolean,
      default: true,
    },
    doMap: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      required: false,
    },
    navigationRoute: {
      type: String,
      required: false,
    },
    route: {
      type: String,
      required: false,
    },
    valueMissingError: {
      type: Error,
      required: false,
      default: () => new GemmaError("Please supply a value", { ref: { type: "Dropdown", id: "Missing" }, ui: true, sensitive: false, data: { fieldName: "dropdown" } }),
    },
    grow: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    const collectionName_ = this.type.CollectionName;
    return {
      route_: this.route || this.type.CollectionNameLower,
      itemName: this.type.ItemNameLower,
      oldSelected: undefined,
      collection: [],
      collectionName_,
      emptyCollection: { label: "No " + collectionName_ },
    };
  },
  computed: {
    mappedCollection() {
      if (this.doMap) {
        return this.map(this.collection, this.mappings.mapSelect, this.mappings.sorters);
      } else {
        return this.collection;
      }
    },
    placeholder_() {
      return this.placeholder || "Please select a " + this.itemName;
    },
  },
  watch: {
    async editing(isEditing, oldIsEditing) {
      if (isEditing && isEditing !== oldIsEditing) {
        if (this.route_) {
          const collection = await this.$app.api.get(this.route_);
          this.collection = collection[this.type.CollectionNameLower];
        } else {
          this.collection = this.items;
        }
      }
    },
    mappedCollection(newMappedCollection) {
      if (newMappedCollection.length === 1) {
        this.selected_ = newMappedCollection[0];
      }
    },
    selected(newItem) {
      if (newItem) {
        Arrays.add(this.collection, { id: newItem.id, label: newItem.label || newItem.name }, idComparer);
        const nItem = this.mappedCollection.find(item => item.id === newItem.id);
        if (nItem && this.selected_ && this.selected_.id !== nItem.id) {
          this.selected_ = nItem;
        }
      } else {
        this.selected_ = undefined;
      }
    },
    selected_(newItem) {
      if (newItem) {
        Arrays.add(this.collection, newItem, idComparer);
      }
    },
  },
  async created() {
    this.oldSelected = this.selected_;
    this.mappings.areEqual = () => {
      if (!this.oldSelected && !this.selected_ && this.oldSelected === this.selected_) {
        return false;
      }

      if ((this.oldSelected && !this.selected_) || (!this.oldSelected && this.selected_)) {
        return false;
      }

      return this.oldSelected.id === this.selected_.id;
    };

    if (this.type.creatingBehaviour) {
      WebApplicationConstants.listenerEventBuses.system.on(this.type.ItemNameUpper + ".Created", this.socketIo_create, this);
    }
    this.bus.$on(Events.Saved, this.onSaved_);
  },
  destroyed() {
    this.bus.$off(Events.Saved, this.onSaved_);
  },
  methods: {
    onUpdate(value) {
      this.bus.$emit(Events.Change, { id: this.id, value });
    },
    onChange_(event) {
      this.$emit(Events.Change, event);
    },
    cancel() {
      this.$emit(Events.Cancel, { value: this.value, value_: this.selected_, oldSelected: this.oldSelected });
    },
    onSaved_({ id, errors }) {
      if (id == this.id && errors.length === 0) {
        this.oldSelected = this.selected_;
      }
    },
    async socketIo_create(event) {
      if (this.type.CollectionNameUpper) {
        const routeToCreated = ApiRoutes[this.type.CollectionNameUpper].Get(event.data.id);
        const item = await this.$app.api.get(routeToCreated);
        let collection = this.collection.slice();
        const newItem = this.doMap ? item : { id: item.id, label: item.label || item.name };
        Arrays.add(collection, newItem, idComparer);
        collection = collection.sort(stringSort(c => c.label));
        this.collection = collection;
        // add sort
      }
    },
    _onValidate({ selected_ }) {
      if (!this.canBeEmpty && !selected_) {
        Arrays.add(this.errors, this.valueMissingError);
        return false;
      }

      return true;
    },
  },
};
</script>
